import { initialState } from '@ispm-client/modules/bpmn-modeler/store/state';
import {
  ActiveNodeNotesPanelAction,
  NodeNotesAction,
  NodeNotesActionTypes
} from '@ispm-client/modules/bpmn-modeler/store/actions';

export function nodesWithNotes(state = initialState.nodesWithNotes, action: NodeNotesAction) {
  switch (action.type) {
    case NodeNotesActionTypes.INIT_NODES_WITH_NOTES:
      return action.payload.nodeIds;
    case NodeNotesActionTypes.ADD_NODE_WITH_NOTES:
      const newState: Set<string> = new Set();
      state.forEach((item) => newState.add(item));
      newState.add(action.payload.nodeId);
      return newState;
    default:
      return state;
  }

}

export function activeNodeNotesPanel(state = initialState.activeNodeNotesPanel, action: ActiveNodeNotesPanelAction) {
  switch (action.type) {
    case NodeNotesActionTypes.ACTIVE_NODE_NOTES_PANEL:
      return action.payload.nodeId;
    default:
      return state;
  }
}
